import { __assign, __rest } from "tslib";
import * as React from 'react';
import { IconButton } from '../../Button';
import { ArrowLeft } from '../../icons/icons/ArrowLeft';
import { ArrowRight } from '../../icons/icons/ArrowRight';
var MonthButton = function (_a) {
    var Icon = _a.Icon, label = _a.label, props = __rest(_a, ["Icon", "label"]);
    return (React.createElement(IconButton, __assign({ Icon: Icon, label: label, size: "small", color: "inverted", hoverBackgroundColor: "inverted", hoverColor: "interaction" }, props)));
};
export var MonthBack = function (props) { return (React.createElement(MonthButton, __assign({ Icon: ArrowLeft, label: "Previous Month" }, props))); };
export var MonthForward = function (props) { return React.createElement(MonthButton, __assign({ Icon: ArrowRight, label: "Next Month" }, props)); };
//# sourceMappingURL=MonthButton.js.map